import api from '../../utils/api';

export type BorzoAssignmentStatus =
  | 'pending'
  | 'accepted'
  | 'rejected'
  | 'picked_up'
  | 'in_transit'
  | 'delivered'
  | 'cancelled';

export type MedicineOrderStatus =
  | 'pending'
  | 'waiting_for_payment'
  | 'payment_completed'
  | 'ready_to_pickup'
  | 'out_for_delivery'
  | 'delivered'
  | 'cancelled'
  | 'cancelled_before_pickup'
  | 'refund_requested'
  | 'refund_completed'
  | 'replacement_requested'
  | 'replacement_delivered';

export interface BorzoDeliveryRow {
  assignmentId: string;
  provider: 'BORZO';
  status: BorzoAssignmentStatus;
  externalOrderId: string | null;
  externalDeliveryId: string | null;
  externalCourierName: string | null;
  externalCourierPhone: string | null;
  pickupLatitude: number;
  pickupLongitude: number;
  pickupAddress: string | null;
  deliveryLatitude: number;
  deliveryLongitude: number;
  deliveryAddress: string | null;
  deliveryCharges: number;
  createdAt: string;
  updatedAt: string;
  order: {
    orderId: string;
    status: MedicineOrderStatus;
    deliveryType: string | null;
    deliveryPartnerProvider: 'BORZO' | 'INTERNAL' | null;
    borzoOrderId: string | null;
    borzoDeliveryId: string | null;
    borzoCourierName: string | null;
    borzoCourierPhone: string | null;
    deliveryCharges: number;
    totalAmount: number;
    paymentStatus: string;
    createdAt: string;
    updatedAt: string;
    vendor: {
      vendorId: string;
      name: string;
      address: string;
      location: string | null;
      contactNumber: string;
    };
    deliveryAddress: {
      addressId: string;
      formattedAddress: string;
      latitude: string;
      longitude: string;
      contactName: string | null;
      contactPhone: string | null;
      city: string;
      state: string;
      zipCode: string;
    } | null;
    user: {
      userId: string;
      name: string | null;
      phone_number: string;
    } | null;
  };
}

export interface BorzoDeliveriesResponse {
  success: boolean;
  message: string;
  data: BorzoDeliveryRow[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export interface BorzoLocationResponse {
  success: boolean;
  data: {
    assignmentId: string;
    orderId: string;
    deliveryPartnerId: string | null;
    latitude: number;
    longitude: number;
    heading: number | null;
    speed: number | null;
    timestamp: string;
  };
  message: string;
}

export async function getBorzoDeliveries(params?: {
  search?: string;
  orderStatus?: string;
  assignmentStatus?: string;
  from?: string;
  to?: string;
  page?: number;
  limit?: number;
}): Promise<BorzoDeliveriesResponse> {
  const res = await api.get('/master-admin/borzo-deliveries', {
    params: {
      search: params?.search || undefined,
      orderStatus: params?.orderStatus || undefined,
      assignmentStatus: params?.assignmentStatus || undefined,
      from: params?.from || undefined,
      to: params?.to || undefined,
      page: params?.page || 1,
      limit: params?.limit || 50,
    },
  });
  return res.data;
}

export async function getBorzoDeliveryLocation(
  assignmentId: string
): Promise<BorzoLocationResponse> {
  const res = await api.get(
    `/master-admin/borzo-deliveries/${encodeURIComponent(assignmentId)}/location`
  );
  return res.data;
}

